export default {
    main: {

    },
    description: {
        textAlign: "center",
        margin: "47px 0 0 0",
        fontSize: "16px",
        color: "#5b5b5b"
    }
}